import React, { FC } from "react";
import DOMPurify from "isomorphic-dompurify";

export interface PurifiedHtmlProps {
  html: string;
  [x: string]: unknown;
}

export const PurifiedHtml: FC<PurifiedHtmlProps> = ({ html, ...rest }) => {
  // in order to prevent malicious redirect hacks from the target website,
  // all links that open in a new window/tab must have the rel attribute set, because
  // IE11 is the only browser that doesn't automatically do this now.
  // https://web.dev/external-anchors-use-rel-noopener/
  // https://sites.google.com/site/bughunteruniversity/nonvuln/phishing-with-window-opener
  const htmlWithSafeLinks = html.replace(
    /target="_blank"/g,
    'target="_blank" rel="noopener noreferrer"'
  );
  const safeHtml = DOMPurify.sanitize(htmlWithSafeLinks, {
    ADD_ATTR: ["target", "rel"],
  });
  return <div dangerouslySetInnerHTML={{ __html: safeHtml }} {...rest} />;
};
